module.exports = __webpack_public_path__ + "static/devices-8b52596b8d31f8709b62cb5e02fcb73b.png";